import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Security: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 660c-3.93 0-7.86-.72-11.6-2.15-38.35-14.27-228.4-97.77-228.4-349.14v-168.7h30v168.7c0 231.7 174.04 308.09 208.93 321.05l.19.07c.59.23 1.16.23 1.74 0l.17-.07c34.89-13.02 208.95-89.68 208.95-321.12v-168.65h30v168.65c0 251.09-190.06 334.88-228.39 349.19-3.75 1.44-7.68 2.16-11.61 2.16z' />
    <path d='m150 120h480v30h-480z' />
    <path d='m453.84 270h-30v-29.67c0-16.73-15.31-30.33-34.14-30.33s-34.14 13.61-34.14 30.33v29.67h-30v-29.67c0-33.27 28.77-60.33 64.14-60.33s64.14 27.07 64.14 60.33z' />
    <path d='m510 480.71h-240.58v-180.71h185.58c30.33 0 55 24.67 55 55zm-210.58-30h180.58v-95.71c0-13.79-11.21-25-25-25h-155.58z' />
  </IconBase>
));

Security.displayName = 'Security';

export default Security;
